import React from 'react';
import { useI18n } from '../context/I18nContext';
import { ChevronDown } from 'lucide-react';

export default function LanguageSwitcher() {
  const { lang, setLang, langs } = useI18n();
  const [open, setOpen] = React.useState(false);
  const current = langs.find((l) => l.code === lang);

  return (
    <div className="relative" data-testid="lang-switcher">
      <button
        onClick={() => setOpen((v) => !v)}
        onBlur={() => setTimeout(() => setOpen(false), 150)}
        className="flex items-center gap-1.5 text-[#c9a961] hover:text-[#d8c180] transition-colors text-xs tracking-[0.18em] uppercase font-medium"
        data-testid="lang-switcher-trigger"
      >
        {current?.label}
        <ChevronDown size={14} />
      </button>
      {open && (
        <div className="absolute right-0 top-full mt-3 min-w-[140px] bg-[#05150f] border border-[#c9a961]/30 z-50 shadow-2xl">
          {langs.map((l) => (
            <button
              key={l.code}
              onMouseDown={() => { setLang(l.code); setOpen(false); }}
              className={`w-full text-left px-4 py-2.5 text-sm font-sans transition-colors hover:bg-[#0d2a1f] hover:text-[#c9a961] ${l.code === lang ? 'text-[#c9a961]' : 'text-[#f5f5f0]'}`}
              data-testid={`lang-option-${l.code}`}
            >
              <span className="text-xs tracking-[0.18em] uppercase mr-2">{l.label}</span>
              <span className="opacity-70">{l.name}</span>
            </button>
          ))}
        </div>
      )}
    </div>
  );
}
